import React, { useState, useEffect, useRef } from 'react';
import TauriVisualFactory from '../TauriVisualFactory/TauriVisualFactory';
import { useFilterContext } from '../TauriGlobalContext/TauriGlobalContext';
import config from '../../appURL.json';
import './TauriSectionBaseVisual.css';

const TauriSectionBaseVisual = ({ visual, columnSize, rowSize, palettes, themes, isModal }) => {
  const [chartData, setChartData] = useState();
  const [isLoading, setIsLoading] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [displayPerPage, setDisplayPerPage] = useState(visual.binding.data?.pagination?.displayPerPage ?? 10);
  const [totalItems, setTotalItems] = useState(0);
  const [onLoadData, setOnLoadData] = useState(null);
  const totalPages = Math.ceil(totalItems / displayPerPage);

  const { filterValue } = useFilterContext();

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsLoading(true);

      try {
        await fetchOnLoad();
        await fetchData();
      } catch (error) {
        console.error("Error during initial data fetch:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, [visual, filterValue, visual.binding.data.parameters]);

  const fetchData = async () => {
    const token = localStorage.getItem('token');
    const storedFilter = localStorage.getItem("filterData");
    const parseStoredFilter = JSON.parse(storedFilter);
    
    const filter = filterValue?.FromMonth ? filterValue : parseStoredFilter;

    const parameters = updateParameters(visual.binding.data.parameters, filter);
    const requestBody = {
      "id": visual.binding.data.endpoint,
      "params": parameters
    };

    try {
      const response = await fetch(config.API_GetData, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        console.error('Failed to fetch data:', response.status);
        setChartData([]);
        return;
      }

      const data = await response.json();
      setChartData(JSON.parse(data.result.data));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchOnLoad = async () => {
    const token = localStorage.getItem('token');
    const storedFilter = localStorage.getItem("filterData");
    const parseStoredFilter = JSON.parse(storedFilter);
    
    const filter = filterValue?.FromMonth ? filterValue : parseStoredFilter;

    const parameters = updateParameters(visual.binding.data.parameters, filter);
    const requestBody = {
      "id": visual.binding.data.onLoad,
      "params": parameters
    };

    try {
      const response = await fetch(config.API_GetData, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        console.error('Failed to fetch data:', response.status);
        setTotalItems(0);
        return;
      }

      const data = await response.json();
      const ol_TotalItems = JSON.parse(data.result.data)[0]?.TotalItems;
      setOnLoadData(JSON.parse(data.result.data)[0]);
      setTotalItems(ol_TotalItems);
    } catch (error) {
      console.log(error);
    }
  };

  const updateParameters = (parameters, dataFilter) => {
    const updatedParameters = [...parameters];

    updatedParameters.forEach((param) => {

      if (dataFilter.hasOwnProperty(param.key) && dataFilter[param.key] !== null && dataFilter[param.key] !== undefined) {
        param.value = dataFilter[param.key];
      }
    });
    return updatedParameters;
  }

  const getPalettes = (ranges) => {
    const foundPalettes = [];
    for (const range of ranges) {
      const palette = palettes.find(palette => palette.id === range);
      if (palette) {
        foundPalettes.push(palette);
      }
    }
    return foundPalettes;
  };

  const getTheme = (themeID, type) => {
    const theme = themes.find(theme => theme.id === themeID); // Find the theme by ID
    if (theme) {
      const chart = theme.charts.find(chart => chart.type === type);
      if (chart) {
        return getPalettes(chart.ranges);
      }
    }
    return [];
  };

  const chartPalettes = getTheme(visual.colorTheme, visual.type);

  const handlePageChange = (page) => {
    setCurrentPage(page);

    const values = { PageIndex: page };

    const updatedParameters = visual.binding.data.parameters.map((param) => {
      if (values.hasOwnProperty(param.key)) {
        return { ...param, value: values[param.key].toString() };
      }
      return param;
    });

    visual.binding.data.parameters = updatedParameters;

  };


  const handleDisplayPerPage = (newDisplayPerPage) => {
    setDisplayPerPage(newDisplayPerPage);
    setCurrentPage(1);

    const values = { PageIndex: 1, ResultsPerPage: newDisplayPerPage };

    const updatedParameters = visual.binding.data.parameters.map((param) => {
      if (values.hasOwnProperty(param.key)) {
        return { ...param, value: values[param.key].toString() };
      }
      return param;
    });

    visual.binding.data.parameters = updatedParameters;

  };

  return (
    <>
      {!isModal && <div className="chart-title">{visual.title}</div>}
      {isLoading ? (
        <div className="loader-container">
          <div class="loader-basevisual"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>

      ) : (
        <>
          {!chartData || !chartData?.[0] ? (
            <div className="no-records-container">There are no records to display</div>
          ) : (
            TauriVisualFactory(
              visual,
              chartData,
              chartPalettes,
              columnSize,
              rowSize,
              palettes,
              themes,
              onLoadData,
              {
                currentPage,
                totalPages,
                onPageChange: handlePageChange,
                displayPerPage,
                onDisplayPerPage: handleDisplayPerPage,
                totalItems,
              }
            )
          )}
        </>
      )}

    </>
  );
};

export default TauriSectionBaseVisual;
